// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/RecommendationLabel/recommendationLabel.scss
// module id = 1378
// module chunks = 10 21